import { render } from "./ProgramAssignApplicants.vue?vue&type=template&id=0ee57e7f"
import script from "./ProgramAssignApplicants.vue?vue&type=script&lang=ts"
export * from "./ProgramAssignApplicants.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./ProgramAssignApplicants.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script